import { CircularProgress, Grid, InputLabel, Tab, Tabs, TextField, Tooltip, Typography } from '@mui/material';
import { Info, X } from '@phosphor-icons/react';
import React, { useEffect, useRef, useState } from 'react';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Button from '../../../Button';
import { MediaPreview } from '../../../../pages/questionBank/MediaPreview';

export default function Recap({ chapterData, handleChange, onFileChange, setChapterData, onSave, loading, handleCancelUpload }) {
    const mediaTypes = ['link', 'upload']
    const [selectedTab, setSelectedTab] = useState(1);
    const [videoPreview, setVideoPreview] = useState(false);
    const [currentContentUrl, setCurrentContentUrl] = useState(null);
    const contentType = 'text-and-video';

    useEffect(() => {
        if (chapterData) {
            let chapterDetails = {
                ...chapterData,
                contentType: 'Video'
            }
            setChapterData(chapterDetails);
            onSave(chapterDetails);
        }
    }, [])

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleMediaPreview = (url) => {
        setCurrentContentUrl(url);
        setVideoPreview(!videoPreview);
    };

    const handlePreviewClose = () => {
        setCurrentContentUrl(null);
        setVideoPreview(!videoPreview)
    }

    return (
        <>
            <Grid item xs={12} >
                <Typography
                    align="left"
                    variant="h6"
                    color="primary.blue"
                    sx={{
                        margin: '0',
                        fontWeight: '700',
                        lineHeight: '1.5',
                        display: 'flex',
                        alignItems: 'center'
                    }}>Media
                    <Tooltip title="Provide link or Upload file">
                        <Info style={{ fontSize: '16px' }} />
                    </Tooltip>
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    {mediaTypes.map((item, index) => (
                        <Tab label={item} key={index} />
                    ))}
                </Tabs>
            </Grid>
            {selectedTab === 0 && (
                <Grid item xs={12}>
                    <InputLabel style={styles.inputLabel}>URL</InputLabel>
                    <Grid container alignItems="center">
                        <Grid item xs={11}>
                            <TextField
                                name="contentURL"
                                fullWidth
                                value={chapterData?.contentURL || ''}
                                placeholder={'Enter Media Link'}
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            )}
            {selectedTab === 1 && (
                <Grid item xs={12}>
                    <InputLabel style={styles.inputLabel}>Video</InputLabel>
                    <span style={{ color: 'grey', fontSize: '0.8em', fontWeight: 500 }}>
                        (Upload video files in <span style={{ color: '#000' }}>.mp4, .mov, .wmv, .avi, .mkv</span> format up to <span style={{ color: '#000' }}>20MB</span> in Size)
                    </span>
                    <Grid container alignItems="center">
                        <Grid item xs={11}>
                            <TextField
                                name="contentURL"
                                fullWidth
                                value={chapterData?.contentURL || ''}
                                placeholder={'Select Video'}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={1}>
                            {loading && <CircularProgress />}
                            {!loading && <FileUploadBtn onFileSelect={(file) => onFileChange(file, 'contentURL')} fileType={"video"} />}
                        </Grid>
                        {loading &&
                            <Button
                                size="small"
                                variant="outlined"
                                color="error"
                                sx={{
                                    mt: 2,
                                    fontSize: '0.8rem',
                                }}
                                onClick={handleCancelUpload}
                                placeholder={<div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><X /> Cancel </div>}
                            />}
                    </Grid>
                </Grid>)}
            {chapterData?.contentURL &&
                <Grid item xs={12}>
                    <Button onClick={() => handleMediaPreview(chapterData?.contentURL)} variant="contained" size="small" color="primary" placeholder={' Play Video'} />
                    <MediaPreview
                        contentURL={currentContentUrl}
                        contentType={contentType}
                        handleClose={handlePreviewClose}
                        mediaPreview={videoPreview}
                    />
                </Grid>
            }
        </>
    )
}

const FileUploadBtn = ({ onFileSelect, fileType }) => {
    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            onFileSelect(file);
        }
    };

    const getAcceptedFormats = () => {
        switch (fileType) {
            case "image":
                return ".jpg, .jpeg, .png, .gif";
            case "video":
                return ".mp4, .mov, .wmv, .avi, .mkv";
            case "audio":
                return ".mp3, .wav";
            default:
                return "*"; // Allow all types if no specific type is defined
        }
    };

    return (
        <div>
            <Button style={styles.uploadBtn} variant='contained' placeholder={<FileUploadIcon sx={{ color: 'var(--mui-palette-primary-blue)' }} />} onClick={handleButtonClick} />
            <input
                type="file"
                style={styles.hiddenInput}
                ref={fileInputRef}
                onChange={handleFileSelect}
                accept={getAcceptedFormats()}
            />
        </div>
    );
};

const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    uploadBtn: {
        width: '30px',
        height: '30px',
        boxShadow: 'none',
        border: 'none',
        backgroundColor: 'transparent',
        padding: 0,
        borderRadius: '0',
        minWidth: '30px'
    },
    hiddenInput: {
        display: 'none',
    }
}
